import { render, staticRenderFns } from "./StaffTabsNotes.vue?vue&type=template&id=2c18f97e&scoped=true&"
import script from "./StaffTabsNotes.vue?vue&type=script&lang=js&"
export * from "./StaffTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18f97e",
  null
  
)

export default component.exports